module.exports = __webpack_public_path__ + "img/main.2a0435b8.svg";